<ng-container *ngIf="userValidation$ && (isOnActiveRoute('editor') || isOnActiveRoute('home') || isOnActiveRoute('')) ">
  <button
    matTooltip="Erweiterte Optionen"
    [matTooltipShowDelay]="300"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    aria-label="editor extended options menu"
  >
    <mat-icon class="icon-display" data-tour="step10">more_vert</mat-icon>
  </button>

  <mat-menu #menu="matMenu">
    <button *ngIf="this.canEdit() && isOnActiveRoute('editor')" mat-menu-item (click)="openResetConfirmDialog()">
      <mat-icon class="icon-display">delete_forever</mat-icon>
      <span>Kartentisch zurücksetzen</span>
    </button>
    <button *ngIf="isOnActiveRoute('editor')"mat-menu-item (click)="openDownloadDialog()">
      <mat-icon class="icon-display">photo</mat-icon>
      <span>Kartennetz herunterladen</span>
    </button>
     <button *ngIf="this.canEdit()" mat-menu-item (click)="startTour()">
      <mat-icon class="icon-display">school</mat-icon>
      <span>Onboarding-Tour starten</span>
    </button>
    <button *ngIf="this.canEdit()" mat-menu-item (click)="downloadAsset('WebApp_und_KI_Assistenz.pdf');">
      <mat-icon class="icon-display">menu_book</mat-icon>
      <span>Ausführliche Anleitung</span>
    </button>
  </mat-menu>
</ng-container>

<ng-template #resetConfirmDialog>
  <div class="modal-wrapper">
  <div class="headline-wrapper">
    <span>Kartentisch zurücksetzen</span>
  </div>
  <mat-dialog-content>
    <span class="dialog-content">Möchtest du den Kartentisch wirklich zurücksetzen? Alle Karten und Verbindungen werden gelöscht. Dieser Vorgang ist nicht rückgängig zu machen.</span>
    <div class="spacer"></div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="cancelReset()">Abbrechen</button>
    <button mat-raised-button color="accent" [mat-dialog-close]="true">Zurücksetzen</button>
  </mat-dialog-actions>
  </div>
</ng-template>
